"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidTypeDescriptor;

var _includes = _interopRequireDefault(require("lodash/includes"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _some = _interopRequireDefault(require("lodash/some"));

function isValidTypeDescriptor(descriptor) {
  var validKeys = ['type', 'payload', 'meta'];

  if (!(0, _isPlainObject.default)(descriptor)) {
    return false;
  }

  if ((0, _some.default)(descriptor, function (value, key) {
    return !(0, _includes.default)(validKeys, key);
  })) {
    return false;
  }

  if (!(0, _isString.default)(descriptor.type)) {
    return false;
  }

  return true;
}